/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import formatCurrency from 'shared/utils/formatCurrency';
import { Col, Row, Table as TableAntd, Typography } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { TableCosting } from 'shared/components';
import { TextTotalPrice, TextTotalRevenue } from './Styles';

const { Text } = Typography;

type ServiceTableProps = {
  haierCostData: any;
};

const TotalPriceTable: React.FC<ServiceTableProps> = ({ haierCostData }) => {
  const {
    totalBeforeDiscount,
    totalDiscount,
    totalAfterDiscount,
    totalVat,
    grandTotal,
  } = haierCostData;

  const columnsTableService = [
    {
      title: '',
      children: [
        {
          title: 'รายการ',
          dataIndex: 'list_name',
          key: 'list_name',
          width: 250,
        },
      ],
    },
    {
      title: 'สรุปรายการต้นทุน',
      style: {
        padding: '6px',
        alignItems: 'flex-end',
        backgroundColor: '#FDDF7C',
        margin: '-6px',
      },
      children: [
        {
          title: 'ราคาต่อหน่วย',
          dataIndex: 'totalBeforeDiscountCost',
          key: 'totalBeforeDiscountCost',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'ส่วนลด',
          dataIndex: 'totalDiscountCost',
          key: 'totalDiscountCost',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'ราคาหลังลด',
          dataIndex: 'totalAfterDiscountCost',
          key: 'totalAfterDiscountCost',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'ภาษีมูลค่าเพิ่ม',
          dataIndex: 'totalVatCost',
          key: 'totalVatCost',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'หัก ณ ที่จ่าย',
          dataIndex: 'totalWhtCost',
          key: 'totalWhtCost',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
        {
          title: 'ราคาต้นทุน',
          dataIndex: 'totalGrandTotalCost',
          key: 'totalGrandTotalCost',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#FFEEB6',
            margin: '-6px',
          },
        },
      ],
    },
    {
      title: 'สรุปรายการรายได้',
      style: {
        padding: '6px',
        alignItems: 'flex-end',
        backgroundColor: '#74B662',
        margin: '-6px',
      },
      children: [
        {
          title: 'ราคาต่อหน่วย',
          dataIndex: 'totalBeforeDiscountSale',
          key: 'totalBeforeDiscountSale',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'ส่วนลด',
          dataIndex: 'totalDiscountSale',
          key: 'totalDiscountSale',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'ราคาหลังลด',
          dataIndex: 'totalAfterDiscountSale',
          key: 'totalAfterDiscountSale',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'ภาษีมูลค่าเพิ่ม',
          dataIndex: 'totalVatSale',
          key: 'totalVatSale',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'หัก ณ ที่จ่าย',
          dataIndex: 'totalWhtSale',
          key: 'totalWhtSale',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
        {
          title: 'ราคาขาย',
          dataIndex: 'totalGrandTotalSale',
          key: 'totalGrandTotalSale',
          width: 100,
          align: 'right',
          style: {
            padding: '6px',
            alignItems: 'flex-end',
            backgroundColor: '#B9DEAF',
            margin: '-6px',
          },
        },
      ],
    },
  ];

  const rowDefaultValue = {
    totalAfterDiscountCost: (
      <div
        style={{
          backgroundColor: '#FFF8E1',
          margin: '-6px',
          padding: '6px',
        }}
      >
        {formatCurrency(0, '-')}
      </div>
    ),
    totalAfterDiscountSale: (
      <div
        style={{
          backgroundColor: '#EDF9E9',
          margin: '-6px',
          padding: '6px',
        }}
      >
        {formatCurrency(0, '-')}
      </div>
    ),
    totalBeforeDiscountCost: (
      <div
        style={{
          backgroundColor: '#FFF8E1',
          margin: '-6px',
          padding: '6px',
        }}
      >
        {formatCurrency(0, '-')}
      </div>
    ),
    totalBeforeDiscountSale: (
      <div
        style={{
          backgroundColor: '#EDF9E9',
          margin: '-6px',
          padding: '6px',
        }}
      >
        {formatCurrency(0, '-')}
      </div>
    ),
    totalDiscountCost: (
      <div
        style={{
          backgroundColor: '#FFF8E1',
          margin: '-6px',
          padding: '6px',
        }}
      >
        {formatCurrency(0, '-')}
      </div>
    ),
    totalDiscountSale: (
      <div
        style={{
          backgroundColor: '#EDF9E9',
          margin: '-6px',
          padding: '6px',
        }}
      >
        {formatCurrency(0, '-')}
      </div>
    ),
    totalGrandTotalCost: (
      <div
        style={{
          backgroundColor: '#FFF8E1',
          margin: '-6px',
          padding: '6px',
        }}
      >
        {formatCurrency(0, '-')}
      </div>
    ),
    totalGrandTotalSale: (
      <div
        style={{
          backgroundColor: '#EDF9E9',
          margin: '-6px',
          padding: '6px',
        }}
      >
        {formatCurrency(0, '-')}
      </div>
    ),
    totalVatCost: (
      <div
        style={{
          backgroundColor: '#FFF8E1',
          margin: '-6px',
          padding: '6px',
        }}
      >
        {formatCurrency(0, '-')}
      </div>
    ),
    totalVatSale: (
      <div
        style={{
          backgroundColor: '#EDF9E9',
          margin: '-6px',
          padding: '6px',
        }}
      >
        {formatCurrency(0, '-')}
      </div>
    ),
    totalWhtCost: (
      <div
        style={{
          backgroundColor: '#FFF8E1',
          margin: '-6px',
          padding: '6px',
        }}
      >
        {formatCurrency(0, '-')}
      </div>
    ),
    totalWhtSale: (
      <div
        style={{
          backgroundColor: '#EDF9E9',
          margin: '-6px',
          padding: '6px',
        }}
      >
        {formatCurrency(0, '-')}
      </div>
    ),
  };

  const listName = [
    {
      key: uuidv4(),
      list_name: 'ราคารวมก่อนส่วนลด',
      totalBeforeDiscountCost: (
        <div
          style={{
            backgroundColor: '#FFF8E1',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(totalBeforeDiscount.cost), '-')}
        </div>
      ),
      totalBeforeDiscountSale: (
        <div
          style={{
            backgroundColor: '#EDF9E9',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(totalBeforeDiscount.sale), '-')}
        </div>
      ),
    },
    {
      key: uuidv4(),
      list_name: 'รวมส่วนลด',
      totalDiscountCost: (
        <div
          style={{
            backgroundColor: '#FFF8E1',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(totalDiscount.cost), '-')}
        </div>
      ),
      totalDiscountSale: (
        <div
          style={{
            backgroundColor: '#EDF9E9',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(totalDiscount.sale), '-')}
        </div>
      ),
    },
    {
      key: uuidv4(),
      list_name: 'ราคารวมหลังส่วนลด',
      totalAfterDiscountCost: (
        <div
          style={{
            backgroundColor: '#FFF8E1',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(totalAfterDiscount.cost), '-')}
        </div>
      ),
      totalAfterDiscountSale: (
        <div
          style={{
            backgroundColor: '#EDF9E9',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(totalAfterDiscount.sale), '-')}
        </div>
      ),
    },
    {
      key: uuidv4(),
      list_name: 'รวมภาษีมูลค่าเพิ่ม 7%',
      totalVatCost: (
        <div
          style={{
            backgroundColor: '#FFF8E1',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(totalVat.cost), '-')}
        </div>
      ),
      totalVatSale: (
        <div
          style={{
            backgroundColor: '#EDF9E9',
            margin: '-6px',
            padding: '6px',
          }}
        >
          {formatCurrency(Number(totalVat.sale), '-')}
        </div>
      ),
    },
  ].map((item) => ({
    ...rowDefaultValue,
    ...item,
  }));

  const dataTable = [...listName];

  return (
    <TableCosting
      bordered
      pagination={false}
      className="table-2"
      dataSource={dataTable}
      style={{ marginTop: 15 }}
      columns={columnsTableService}
      summary={() => {
        return (
          <TableAntd.Summary.Row>
            <TableAntd.Summary.Cell colSpan={1} index={1}>
              <Text strong>รวม / Total</Text>
            </TableAntd.Summary.Cell>
            <TableAntd.Summary.Cell colSpan={6} index={1}>
              <Row
                justify="end"
                align="middle"
                gutter={[16, 0]}
                style={{
                  backgroundColor: '#FFF8E1',
                  margin: '-6px',
                  padding: '6px',
                }}
              >
                <Col>
                  <Text strong>ต้นทุนสุทธิ / Net Cost</Text>
                </Col>
                <Col>
                  <Text strong>
                    <TextTotalPrice>{`${formatCurrency(
                      Number(grandTotal.cost),
                    )} บาท`}</TextTotalPrice>
                  </Text>
                </Col>
              </Row>
            </TableAntd.Summary.Cell>
            <TableAntd.Summary.Cell colSpan={7} index={1}>
              <Row
                justify="end"
                align="middle"
                gutter={[16, 0]}
                style={{
                  backgroundColor: '#EDF9E9',
                  margin: '-6px',
                  padding: '6px',
                }}
              >
                <Col>
                  <Text strong>รายได้สุทธิ / Net Revenue</Text>
                </Col>
                <Col>
                  <Text strong>
                    <TextTotalRevenue>{`${formatCurrency(
                      Number(grandTotal.sale),
                    )} บาท`}</TextTotalRevenue>
                  </Text>
                </Col>
              </Row>
            </TableAntd.Summary.Cell>
          </TableAntd.Summary.Row>
        );
      }}
    />
  );
};

export default TotalPriceTable;
